import React from "react";
import styles from "./Fire.module.css";

/**
 * <Embers/> — brasas que sobem do fogo e desaparecem, em loop contínuo.
 * Renderizado dentro do .stage de <Fire/> e <StreakFire/>. Visível apenas
 * quando o fogo está aceso (controlado por .fc.lit .embers no CSS).
 *
 * Configs fixas (sem random por render) para uma distribuição agradável:
 *   x0  — deslocamento horizontal inicial (px)
 *   x1  — deslocamento horizontal final (drift lateral ao subir)
 *   dur — duração do ciclo (s)
 *   delay — atraso inicial (s) para escalonar as brasas
 *   s   — escala da bolinha
 */
const EMBERS = [
  { x0: -2, x1: -14, dur: 2.4, delay: 0.0, s: 1.0 },
  { x0: 6, x1: 16, dur: 2.9, delay: 0.5, s: 0.8 },
  { x0: -10, x1: -20, dur: 3.2, delay: 1.1, s: 0.7 },
  { x0: 10, x1: 22, dur: 2.6, delay: 1.6, s: 0.9 },
  { x0: 0, x1: -6, dur: 3.0, delay: 0.9, s: 1.1 },
  { x0: -6, x1: 8, dur: 2.7, delay: 2.0, s: 0.7 },
  { x0: 14, x1: 10, dur: 3.4, delay: 1.4, s: 0.8 },
  { x0: -14, x1: -4, dur: 2.5, delay: 0.3, s: 0.9 },
];

export default function Embers() {
  return (
    <div className={styles.embers} aria-hidden="true">
      {EMBERS.map((e, i) => (
        <span
          key={i}
          className={styles.ember}
          style={{
            "--ember-x0": `${e.x0}px`,
            "--ember-x1": `${e.x1}px`,
            "--ember-dur": `${e.dur}s`,
            "--ember-delay": `${e.delay}s`,
            "--ember-s": e.s,
          }}
        />
      ))}
    </div>
  );
}
